import "core-js/modules/es.function.name.js";
import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-977618f0"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "userSheet"
};
var _hoisted_2 = {
  class: "sheet-type"
};
var _hoisted_3 = {
  key: 0,
  class: "iconfont icon-youjiantou"
};
var _hoisted_4 = {
  key: 1,
  class: "iconfont icon-xiajiantou"
};
var _hoisted_5 = {
  class: "sheet-list"
};
var _hoisted_6 = ["onClick"];

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-musiclist"
  }, null, -1
  /* HOISTED */
  );
});

var _hoisted_8 = {
  class: "linelittle"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createCommentVNode(" 创建和收藏的歌单 "), _createElementVNode("div", _hoisted_2, [_createCommentVNode(" 标题 "), _createElementVNode("div", {
    class: "sheet-item-title",
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    function () {
      return _ctx.titleClick && _ctx.titleClick.apply(_ctx, arguments);
    })
  }, [!_ctx.isList ? (_openBlock(), _createElementBlock("i", _hoisted_3)) : (_openBlock(), _createElementBlock("i", _hoisted_4)), _createElementVNode("span", null, _toDisplayString(_ctx.sheetType), 1
  /* TEXT */
  )]), _createCommentVNode(" 列表 "), _withDirectives(_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sheetList, function (item) {
    return _openBlock(), _createElementBlock("div", {
      class: "sheet-item",
      key: item,
      onClick: function onClick($event) {
        return _ctx.userSheetClick(item.id);
      }
    }, [_hoisted_7, _createElementVNode("span", _hoisted_8, _toDisplayString(item.name), 1
    /* TEXT */
    )], 8
    /* PROPS */
    , _hoisted_6);
  }), 128
  /* KEYED_FRAGMENT */
  ))], 512
  /* NEED_PATCH */
  ), [[_vShow, _ctx.isList]])])]);
}